import {setupFetchCsrf} from './common/csrf';
import {initInvoicePreview} from './common/invoice-preview';
import {setupI18n} from './i18n';
import {documentReady} from "./document-ready";
import {setupLogoutHandler} from "./handle-logout";
import {setupOAuthPopup} from "./oauth-popup";
import {action, controller, importRouteJs} from "./routes";

if (controller === 'admin' || controller === 'report') {
    initInvoicePreview();
    import('./admin/init');
}
import {handleHeaderSidenav, setupOrganisationDropdownListeners} from "./header";
import {setupAppShell} from "./shell";
import {setupThemeModeSwitcher} from "./theme-mode";
import {defaultEmptyCbarSelectValues, setupCbarSelectHydration, setupCbarSelectJqueryBridge, setupCbarSelectSubmitSync} from "./cbar-select-bridge";
import {setupCbarDateInputBridge} from "./cbar-date-input-bridge";
import {setupCbarCheckboxBridge} from "./cbar-checkbox-bridge";
import {setupCbarSelectSizing} from "./cbar-select-sizing";
import {setupMobileDatatableColumnVisibility} from "./cbar-datatable";
import {setupFilterCardOverflowWhenReady} from "./common/filter-card-overflow";
import {setupDatatableScrollHintsWhenReady} from "./common/datatable-scroll-hint";
import {silentLoginCallback} from "@cbar/cbar-oauth";
import './controllers/helper/init';

setupFetchCsrf();

// Import the js for this controller/action, if it exists.
importRouteJs(controller, action)
    .catch(() => 'No file found, that\'s ok.');

import './datatables/registry';

documentReady().then(async e => {
    await setupI18n();

    // Handle silent sign in callback
    silentLoginCallback();

    // Set up our OAuthPopup
    setupOAuthPopup();
    setupLogoutHandler();
    await setupOrganisationDropdownListeners();
    setupAppShell();
    await setupThemeModeSwitcher();
    setupCbarSelectJqueryBridge();
    setupCbarSelectSubmitSync();
    defaultEmptyCbarSelectValues();
    void setupCbarSelectHydration();
    setupCbarDateInputBridge();
    setupCbarCheckboxBridge();
    setupCbarSelectSizing();
    setupMobileDatatableColumnVisibility();
    void setupFilterCardOverflowWhenReady();
    setupDatatableScrollHintsWhenReady();

    handleHeaderSidenav();

});
